@if (isWide()) {
  @if (menuConfiguration()?.useFavoriteMenuItems) {
    <button type="button" mat-icon-button (click)="favoriteButtonClick.emit()">
      @if (isAddFavoriteEnabled()) {
        <mat-icon [matTooltip]="'Menu.ToggleOffAddingToFavorites' | translate"> favorite </mat-icon>
      } @else {
        <mat-icon [matTooltip]="'Menu.ToggleOnAddingToFavorites' | translate"> favorite_border </mat-icon>
      }
    </button>
  }
}
